import api from "../index";

// Types
interface PlanQueryParams {
  page?: number;
  limit?: number;
  status?: string;
  visibility?: string;
  planType?: string;
  sortBy?: string;
  sortOrder?: number;
}

// Create a plan
export const createPlan = async (values: any) => {
  return await api.post("/plan", values);
};

// Get all plans with pagination and filters
export const getAllPlans = async (params?: PlanQueryParams) => {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, String(value));
      }
    });
  }
  const queryString = queryParams.toString();
  return await api.get(`/plans${queryString ? `?${queryString}` : ""}`);
};

// Get public plans (for pricing page)
export const getPublicPlans = async () => {
  return await api.get("/plans/public");
};

// Get plan stats
export const getPlanStats = async () => {
  return await api.get("/plans/stats");
};

// Get a plan by id
export const getPlanById = async (id: string) => {
  return await api.get(`/plan/${id}`);
};

// Get a plan by slug
export const getPlanBySlug = async (slug: string) => {
  return await api.get(`/plan/slug/${slug}`);
};

// Update a plan by id
export const updatePlanById = async (id: string, values: any) => {
  return await api.put(`/plan/${id}`, values);
};

// Delete a plan by id
export const deletePlanById = async (id: string) => {
  return await api.delete(`/plan/${id}`);
};

// Duplicate a plan
export const duplicatePlan = async (id: string) => {
  return await api.post(`/plan/${id}/duplicate`);
};

// Update plan status
export const updatePlanStatus = async (id: string, status: string) => {
  return await api.patch(`/plan/${id}/status`, { status });
};

// Update plan visibility
export const updatePlanVisibility = async (id: string, visibility: string) => {
  return await api.patch(`/plan/${id}/visibility`, { visibility });
};

// Toggle popular status
export const togglePlanPopular = async (id: string) => {
  return await api.patch(`/plan/${id}/toggle-popular`);
};

// Update display order
export const updatePlansDisplayOrder = async (
  orderUpdates: { id: string; displayOrder: number }[]
) => {
  return await api.patch("/plans/display-order", { orderUpdates });
};

// Link coupon to plan
export const linkCouponToPlan = async (planId: string, couponId: string) => {
  return await api.post(`/plan/${planId}/link-coupon`, { couponId });
};

// Unlink coupon from plan
export const unlinkCouponFromPlan = async (planId: string, couponId: string) => {
  return await api.post(`/plan/${planId}/unlink-coupon`, { couponId });
};

// Set default coupon for plan
export const setDefaultCoupon = async (planId: string, couponId: string | null) => {
  return await api.post(`/plan/${planId}/default-coupon`, { couponId });
};

// Compare plans
export const comparePlans = async (planIds: string[]) => {
  return await api.post("/plans/compare", { planIds });
};

// Get upgrade suggestions
export const getUpgradeSuggestions = async (currentTier: number) => {
  return await api.get(`/plans/upgrade-suggestions?currentTier=${currentTier}`);
};
